import React, { useEffect } from "react";
import { useMyOrdersQuery } from "../../redux/api/orderApi";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { MDBDataTable } from "mdbreact";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import MetaData from "../../components/layout/MetaData";
import { useDispatch } from "react-redux";
import { clearCart } from "../../redux/features/cartSlice";
import BreadcrumbMyOrders from "../../components/layout/Breadcrumb/breadcrumbMyOrders";

const MyOrders = () => {
  const { data, isLoading, error } = useMyOrdersQuery();

  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const orderSuccess = searchParams.get("order_success");

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }

    if (orderSuccess) {
      dispatch(clearCart());
      navigate("/me/orders");
    }
  }, [error, orderSuccess, dispatch, navigate]);

  const setOrders = () => {
    const orders = {

      columns: [
        { label: "ID", field: "id", sort: "asc" },
        { label: "Amount", field: "amount", sort: "asc" },
        { label: "Payment Status", field: "status" , sort: "asc" },
        { label: "Order Status", field: "orderStatus", sort: "asc" },
        { label: "Actions", field: "actions", sort: "asc" },
      ],
      rows: [],
    };

    data?.orders?.forEach((order) => {
      orders.rows.push({
        id: order?._id,
        amount: `$${order?.totalAmount}`,
        status:order?.paymentInfo?.status?.toUpperCase(),
        orderStatus: order?.orderStatus,
        actions: (
          <>
            <Link
              to={`/me/order/${order?._id}`}
              className="text-blue-500 hover:text-blue-700 px-2 py-1 border border-blue-500 rounded-md"
            >
              <i className="fas fa-eye"></i>
            </Link>
            <Link
              to={`/invoice/order/${order?._id}`}
              className="text-green-500 hover:text-green-700 px-2 py-1 border border-green-500 rounded-md ml-2"
            >
              <i className="fas fa-print"></i>
            </Link>
          </>
        ),
      });
    });

    return orders;
  };

  if (isLoading) return <Loader />;

  return (
    <div className="container mx-auto px-4 py-4">
      <MetaData title="My Orders" />
      <BreadcrumbMyOrders />

      <h1 className="text-2xl font-semibold my-5">{data?.orders?.length} Orders</h1>

      <MDBDataTable
        data={setOrders()}
        className="px-3"
        bordered
        striped
        hover
      />
    </div>
  );
};

export default MyOrders;

